module.exports = __webpack_public_path__ + "img/three_new.db8a4ba8.png";